module.exports = __webpack_public_path__ + "img/app2.1fcfae40.png";